const getMediaUrls = featuredHeader => {
  const {
    web: { videoAssetId: desktopVideoUrl, imageUrl: desktopImageUrl },
    app: { videoAssetId: mobileVideoUrl, imageUrl: mobileImageUrl }
  } = featuredHeader;

  return {
    mobile: {
      imageUrl: mobileImageUrl,
      videoUrl: mobileVideoUrl
    },
    desktop: {
      imageUrl: desktopImageUrl,
      videoUrl: desktopVideoUrl
    }
  };
};

export default getMediaUrls;
